require('./bootstrap');


$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});


$(document).ready(function () {

    $('button.clear-input').click(clearInput);
    $('button.clear-select').click(clearSelect);

    Inputmask("decimal", {
        radixPoint: ",",
        groupSeparator: "",
        digits: 2,
        digitsOptional: false,
        autoGroup: true,
        allowMinus: false
    }).mask('input.numeric8-2');
    Inputmask("integer", {
        groupSeparator: "",
        autoGroup: true,
        autoUnmask: true
    }).mask('input.integer');
    Inputmask({mask: "[A|9|_]", repeat: 15, greedy: false}).mask('input.symbol');

    initSortable();

    $('select#user_id_partner_adres').change(function () {
        $('form#user_id_partner_adres_form').submit();
    });

});


function clearInput() {
    var id = this.getAttribute('data-id');
    $('#' + id).val('');

    var id2 = this.getAttribute('data-add-to-clear');
    $('#' + id2).val('');

    return false;
}


function clearSelect() {
    var id = this.getAttribute('data-id');
    $('#' + id).prop('selectedIndex', 0);
    return false;
}

function initSortable() {
    if (!($('table th.sortable').length)) {
        return;
    }

    var sortingSort = $('#sz_sorting_sort').val();
    var sortingOrder = $('#sz_sorting_order').val();

    $('table th.sortable').each(function (key, val) {
        var el = $(val);
        var sorter = el.data('sortby');

        if (sorter === sortingSort) {
            if (sortingOrder === 'desc') {
                el.addClass('sortable-down');
            } else {
                el.addClass('sortable-up');
            }
        }

        el.click(function () {
            if (el.hasClass('sortable-up')) {
                sorting(sorter, 'desc');
            } else {
                sorting(sorter, 'asc');
            }
        });
    });
}

function sorting(sort, order) {
    $('#sz_sorting_sort').val(sort);
    $('#sz_sorting_order').val(order);
    $('form.filter-form').submit();
}

